import * as React from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import { platformFonts } from "../tickitPlatformTheme";

const DOT_STYLES = {
  success: { bg: "#D1FAE5", color: "#065F46", Icon: CheckIcon },
  error: { bg: "#FEE2E2", color: "#991B1B", Icon: CloseIcon },
  info: { bg: "#DBEAFE", color: "#1E40AF", Icon: PersonAddOutlinedIcon },
};

export default function PlatformTimeline({ items = [], emptyMessage = "Waiting for scan…" }) {
  if (!items.length) {
    return (
      <Typography sx={{ fontSize: "13px", color: "var(--platform-text-3)", fontFamily: platformFonts.body, py: 2 }}>
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {items.map((item, index) => {
        const style = DOT_STYLES[item.type] || DOT_STYLES.success;
        const DotIcon = style.Icon;
        const isLast = index === items.length - 1;
        return (
          <Box
            key={item.id || index}
            sx={{
              display: "flex",
              gap: 2,
              pb: isLast ? 0 : 2.5,
              position: "relative",
              "&:not(:last-child)::before": {
                content: '""',
                position: "absolute",
                left: 15,
                top: 32,
                bottom: 0,
                width: 1.5,
                bgcolor: "var(--platform-border-2)",
              },
            }}
          >
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: style.bg,
                color: style.color,
              }}
            >
              <DotIcon sx={{ fontSize: 16 }} />
            </Box>
            <Box sx={{ flex: 1, pt: 0.25 }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "var(--platform-text)",
                  fontFamily: platformFonts.body,
                  mb: 0.375,
                }}
              >
                {item.title}
              </Typography>
              <Typography sx={{ fontSize: "12px", color: "var(--platform-text-3)", fontFamily: platformFonts.body }}>
                {item.time}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
